import { createActions } from 'redux-actions';
import { GENE_FIRST_BIND, GENE_STATUS } from '../actionTypes';

export default createActions({
  [GENE_FIRST_BIND]: state => {
    return state;
  },
  [GENE_STATUS]: state => {
    return state;
  }
});
